import { AuthenticatedLayout } from "@components/layouts/AuthenticatedLayout";
import { ContactsMessagesView } from "@containers/contacts/ContactsMessagesView";

const ContactsPage = () => {
    return (
        <AuthenticatedLayout activeMenuItem="contacts">
            <ContactsMessagesView />
        </AuthenticatedLayout>
    );
}

export default ContactsPage;